const e = {
  name: "Retail",
  dimensions: { width: 39, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39 34" style="enable-background:new 0 0 39 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,6c0-2.2,1.8-4,4-4s4,1.8,4,4c0,2.2-1.8,4-4,4h-1v5.4L3.3,22.8c-2,1-3.3,3-3.3,5.3v0.1
			C0,31.4,2.6,34,5.9,34h27.2c3.3,0,5.9-2.6,5.9-5.9c0-2.3-1.3-4.4-3.4-5.3L20,15.4v-3.5c2.8-0.5,5-2.9,5-5.9c0-3.3-2.7-6-6-6
			s-6,2.7-6,6H15z M4.2,24.5L19,17.1l15.8,7.5c1.4,0.6,2.2,2,2.2,3.5c0,2.2-1.7,3.9-3.9,3.9H5.9C3.7,32,2,30.3,2,28.1V28
			C2,26.6,2.8,25.2,4.2,24.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Retail
};
